// Function to make a string <s> plural if it refers to a plural amount <n> of items.
// Will add <plural> to the end of the string if appropriate. Users can set "plural"
// to "es" for words where that's appropriate.
// Used to make our messages sound grammatically correct.
export function pluralize(s: string, n: number, plural = "s") {
  if (n === 0 || n > 1) {
    return `${s}${plural}`;
  }
  return s;
}
